const { safeInternalPath } = require('../../router/safeInternalPath');

const carolineShareLink = (deepLinks, origin) => {
    const value = deepLinks?.metaDetailsStreams || deepLinks?.metaDetailsVideos;
    if (typeof value !== 'string') return null;
    const path = safeInternalPath(value.startsWith('#') ? value.slice(1) : value);
    if (!path || !/^\/(?:metadetails|detail)(?:\/|$)/.test(path)) return null;
    return `${origin}/#${path}`;
};

module.exports = carolineShareLink;
